// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.create-event-ul[data-v-ae49b3d2] {\n    min-width: 6rem;\n}\n", ""]);
// Exports
module.exports = exports;
